<form [formGroup]="formulario">
    <div class="row ml-4 mr-4">
        <div class="col-12">
            <mat-tab-group (selectedTabChange)="getListSite($event)">
                <mat-tab label="{{category.name}}" *ngFor="let category of listCategorySite">

                </mat-tab>
            </mat-tab-group>
        </div>
        <div class="col-lg-12 col-md-12 col-xs-12 col-xl-12 col-sm-12 pt-4">
            <mat-form-field class="w-100" appearance="outline" floatLabel="always">
                <mat-label class="InputLabelColor">Site</mat-label>
                <mat-select #txtSite formControlName="site" disableCenteringOption
                    (selectionChange)="changeSite($event.value)">
                    <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                        (keyup)="createFilterSite($event.target.value)">
                    <mat-option *ngFor="let item of listSite" [value]="item.initials">
                        {{item.initials | uppercase}}
                    </mat-option>
                </mat-select>
                <mat-error>{{hasErrorFormControl()}}</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="row ml-4 mr-4" *ngIf="!!dashboardMenuDTO">
        <ng-container *ngFor="let item of dashboardMenuDTO">
            <div class="col-lg-3 col-md-4 col-xs-12 col-xl-2 col-sm-12 pt-4">
                <mat-card class="dashboardCardColor">
                    <mat-card-header (click)="goToRoute(item)" matTooltip="{{item.menu | uppercase}}"
                        class="{{enableCursor ? 'cardCursor' : 'cardNotCursor'}}">
                        <div mat-card-avatar [style.background-image]="'url(../../../assets/' + item.imagem + ')'"
                            class="imageCard" *ngIf="!!item.imagem"></div>
                        <!-- <mat-card-title>Formulário</mat-card-title> -->
                        <mat-card-subtitle class="dashboardCardTexto">{{item.menu | uppercase}}</mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
        </ng-container>
    </div>
</form>